import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	lunchHours: null,
	error: "",
	loading: false,
};

// ADD_category
export const addLunchHours = createAsyncThunk(
	"lunchHours/addLunchHours",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `lunchHours/`,
				data: {
					...values,
				},
			});
			toast.success("Category added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Category try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_category
export const deleteLunchHours = createAsyncThunk(
	"lunchHours/deleteLunchHours ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `lunchHours/${id}`,
			});

			toast.success("Category deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting lunchHours try again");
			console.log(error.message);
		}
	}
);



// categoryS
export const getAllLunchHours = createAsyncThunk(
	"lunchHours/getAllLunchHours",
	async () => {
		try {
			const { data } = await axios.get(`lunchHours/`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateLunchHours = createAsyncThunk(
    "lunchHours/updateLunchHours",
    async ({ id, formattedValues }) => {  // Changed from values to formattedValues
        try {
            const { data } = await axios({
                method: "put",
                url: `lunchHours/${id}`,
                data: {
                    name: formattedValues.name,
                    startTime: formattedValues.startTime,
                    endTime: formattedValues.endTime
                },
            });
            toast.success("Lunch hours updated successfully!");
            return {
                data,
                message: "success",
            };
        } catch (error) {
            toast.error("Error in updating lunch hours. Please try again");
            console.log(error.message);
            return {
                message: "error",
            };
        }
    }
);

const lunchHoursSlice = createSlice({
	name: "lunchHours",
	initialState,
	reducers: {
		clearCategory: (state) => {
			state.lunchHours = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllLunchHours ======

		builder.addCase(getAllLunchHours.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllLunchHours.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllLunchHours.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addLunchHours  ======

		builder.addCase(addLunchHours.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addLunchHours.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addLunchHours.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for lunchHours ======

		builder.addCase(updateLunchHours.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateLunchHours.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateLunchHours.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteLunchHours  ======

		builder.addCase(deleteLunchHours.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteLunchHours.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteLunchHours.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default lunchHoursSlice.reducer;
export const { clearCategory } = lunchHoursSlice.actions;
